// custom typefaces
import "typeface-montserrat";
import "typeface-merriweather";
export { wrapPageElement } from "./src/context/locale-context";
